var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 3.16667H3.95833C3.08388 3.16667 2.375 3.87555 2.375 4.75V15.8333C2.375 16.7078 3.08388 17.4167 3.95833 17.4167H15.0417C15.9161 17.4167 16.625 16.7078 16.625 15.8333V4.75C16.625 3.87555 15.9161 3.16667 15.0417 3.16667Z",
    className: "svgStroke",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 1.58333V4.75",
    className: "svgStroke",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 1.58333V4.75",
    className: "svgStroke",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 7.91667H16.625",
    className: "svgStroke",
    strokeWidth: 0.791667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.13a07af538b6ba5ea73853b0484537de.svg";
export { ForwardRef as ReactComponent };